/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'ai-mate.chat-error-banner.description': 'Seu histórico de bate-papo é salvo por até 30 dias.',
  'ai-mate.chat-error-banner.title': 'Iniciar novo bate-papo',
  'ai-mate.chat-error.description': 'Tente <btn>recarregar o bate-papo</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Você atingiu o número máximo de solicitações. Tente de novo mais tarde.',
  'ai-mate.chat-error.rate-limited-title': 'Muitas solicitações',
  'ai-mate.chat-error.rovo-inactive-description':
    'Parece que o Rovo não está habilitado no site. <link>Configurar o Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'O Rovo está inativo',
  'ai-mate.chat-error.title': 'A gente não sabe o que deu errado',
  'conversation-assistant-button.label': 'Bate-papo',
  'conversation-assistant-button.rovo-chat-label': 'Chat Rovo',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Pergunte ao Atlassian Intelligence sobre isso',
  'highlight-actions.rovo-chat-explain-option.text': 'Explique',
  'highlight-actions.rovo-chat-explain-prompt': 'Explique isso: {selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Recomendações de bate-papo',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Abrir bate-papo',
  'highlight-actions.rovo-chat-summarize-option.text': 'Resumir',
  'highlight-actions.rovo-chat-summarize-prompt': 'Resuma isso: {selectedText}',
  'highlight-actions.rovo-chat.button-text': 'Bate-papo',
  'horizontal-scroll-container.scroll-left': 'Rolar para a esquerda',
  'horizontal-scroll-container.scroll-right': 'Rolar para a direita',
};
